class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.autoCloseTimer = null;

    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener(
      'transitionend',
      () => {
        this.notification.focus();
        trapFocus(this.notification);
      },
      { once: true }
    );

    document.body.addEventListener('click', this.onBodyClick);
    
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
    }
    
    this.autoCloseTimer = setTimeout(() => {
      this.close();
    }, 2000);
  }

  close() {
    this.notification.classList.remove('active');
    document.body.removeEventListener('click', this.onBodyClick);

    // 延迟移除焦点陷阱，避免干扰其他 UI 元素的打开
    setTimeout(() => {
      removeTrapFocus(this.activeElement);
    }, 100);
    
    if (this.autoCloseTimer) {
      clearTimeout(this.autoCloseTimer);
      this.autoCloseTimer = null;
    }
  }

  renderContents(parsedState) {
    this.cartItemKey = parsedState.key;
    
    const isSubscriptionProduct = this.checkIfSubscriptionProduct(parsedState);
    const isMobile = window.innerWidth < 989;
    
    if (isSubscriptionProduct && !isMobile) {
      this.notification.classList.remove('animate', 'active');
      this.updateCartIconOnly(parsedState);
      
      if (typeof publish !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'cart-notification-subscription',
          cartData: parsedState
        });
      }
      
      return;
    }
    
    this.getSectionsToRender().forEach((section) => {
      if (section.isSubscriptionBox) {
        return;
      }
      
      const element = document.getElementById(section.id);
      if (element && parsedState.sections[section.id]) {
        element.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.id],
          section.selector
        );
      }
    });
    
    this.updateSubscriptionBoxSection(parsedState);

    if (this.header) this.header.reveal();
    this.open();
  }
  
  checkIfSubscriptionProduct(parsedState) {
    if (parsedState.selling_plan_allocation) {
      return true;
    }
    
    if (parsedState.items && parsedState.items.length > 0) {
      const addedItem = parsedState.items.find(item => item.key === this.cartItemKey);
      if (addedItem && addedItem.selling_plan_allocation) {
        return true;
      }
    }
    
    return false;
  }
  
  updateCartIconOnly(parsedState) {
    const cartIconSection = parsedState.sections['cart-icon-bubble'];
    if (cartIconSection) {
      const cartIconElement = document.getElementById('cart-icon-bubble');
      if (cartIconElement) {
        const newHTML = this.getSectionInnerHTML(cartIconSection, '.shopify-section');
        cartIconElement.innerHTML = newHTML;
      }
    }
    
    this.updateSubscriptionBoxSection(parsedState);
  }
  
  updateSubscriptionBoxSection(parsedState) {
    const subscriptionBox = document.querySelector('subscription-box');
    
    if (!subscriptionBox) return;
    
    const parentSection = subscriptionBox.closest('.shopify-section[id]');
    if (!parentSection) return;
    
    let sectionId = parentSection.id;
    if (sectionId?.startsWith('shopify-section-')) {
      sectionId = sectionId.replace('shopify-section-', '');
    }
    
    if (!parsedState.sections || !parsedState.sections[sectionId]) {
      return;
    }
    
    const sectionHTML = parsedState.sections[sectionId];
    const html = new DOMParser().parseFromString(sectionHTML, 'text/html');
    const newSubscriptionBoxElement = html.querySelector('subscription-box');
    
    if (newSubscriptionBoxElement) {
      subscriptionBox.innerHTML = newSubscriptionBoxElement.innerHTML;
      
      if (typeof subscriptionBox.init === 'function') {
        subscriptionBox.init();
      }
    }
  }

  getSectionsToRender() {
    const sections = [
      {
        id: 'cart-notification-product',
        selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
      },
      {
        id: 'cart-notification-button',
      },
      {
        id: 'cart-icon-bubble',
      },
    ];
    
    const subscriptionBox = document.querySelector('subscription-box');
    if (subscriptionBox) {
      const parentSection = subscriptionBox.closest('.shopify-section[id]');
      if (parentSection) {
        let sectionId = parentSection.id;
        if (sectionId?.startsWith('shopify-section-')) {
          sectionId = sectionId.replace('shopify-section-', '');
        }
        sections.push({
          id: sectionId,
          section: sectionId,
          isSubscriptionBox: true,
        });
      }
    }
    
    return sections;
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    try {
      const parsedHTML = new DOMParser().parseFromString(html, 'text/html');
      const element = parsedHTML.querySelector(selector);
      return element ? element.innerHTML : '';
    } catch (error) {
      console.warn('Failed to parse section HTML:', error);
      return '';
    }
  }

  handleBodyClick(evt) {
    const target = evt.target;
    
    // 如果是购物车相关按钮，不处理
    if (target.closest('cart-drawer') || 
        target.closest('.cart-notification_button') ||
        target.classList.contains('view-cart') ||
        target.id === 'cart-icon-bubble') {
      return;
    }
    
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure, header-menu');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-notification', CartNotification);
